<template>
    <div class="message">
        <div class="message-header">
            <p>Agregar nuevo anuncio general...</p>
        </div>
        <div class="message-body">
            <form
                @submit.prevent="onSubmit"
                @keydown="form.errors.clear($event.target.name)"
            >
                <p class="control">
                    <textarea
                        placeholder="Escriba su nuevo mensaje"
                        name="body"
                        class="textarea"
                        v-model="form.body"
                    ></textarea>
                </p>
                <p class="control">
                    <span
                        class="help is-danger"
                        v-if="form.errors.has('body')"
                        v-text="form.errors.get('body')"
                    ></span>
                </p>
                <p class="control">
                    <button
                        class="button is-primary"
                        :disabled="form.errors.any()"
                    >
                        Enviar
                    </button>
                </p>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: new Form({ body: "" })
        };
    },

    methods: {
        onSubmit() {
            // submit request to server

            this.form
                .post("./statuses")
                .then(status => this.$emit("completed", status))
                .catch(err=>{

                    if(err.response.status == 401){

                        window.location = "./login";

                        console.log("ERROR: No autorizado");
                    }


                    console.error("Falla solicitud: ",err)

                });
            //alert("All done!"))
        }
    }
};
</script>
